import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class BrokerStylingService {

  private titleService = inject(Title)

  faviconElement!: HTMLLinkElement | null

  constructor() { }

  brokerList: BrokerDetail[] = [
    {
      name: 'Chill',
      brokerId: '01',
      domain: 'hfq.chill.ie',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.chill.ie/company/legal/privacy-policy/',
      termsOfBusinessUrl: 'https://www.chill.ie/company/legal/terms-of-business/',
      journeyGuideUrl: 'https://chill-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+Car+%26+Home+Quote+Journey+Guide.pdf',
      retrieveJourneyGuideUrl: 'https://chill-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+RetrieveResume+Quote+Guide.pdf',
      assumptionsUrl: 'https://www.chill.ie/home-insurance/assumptions/',
      gtm: 'GTM-7DRT',
      noResultPhoneNumber: '01 279 9870'
    },
    {
      name: 'Chill',
      brokerId: '01',
      domain: 'dev-hfq.chill.ie',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.chill.ie/company/legal/privacy-policy/',
      termsOfBusinessUrl: 'https://www.chill.ie/company/legal/terms-of-business/',
      journeyGuideUrl: 'https://www.chill.ie/home-insurance/journey-guide/',
      retrieveJourneyGuideUrl: 'https://chill-uat-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+RetrieveResume+Quote+Guide.pdf',
      assumptionsUrl: 'https://www.chill.ie/home-insurance/assumptions/',
      gtm: 'GTM-TTC826',
      noResultPhoneNumber: '01 279 9870'
    },
    {
      name: 'Chill',
      brokerId: '01',
      domain: 'uat-hfq.chill.ie',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.chill.ie/company/legal/privacy-policy/',
      termsOfBusinessUrl: 'https://www.chill.ie/company/legal/terms-of-business/',
      journeyGuideUrl: 'https://chill-uat-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+Car+%26+Home+Quote+Journey+Guide.pdf',
      retrieveJourneyGuideUrl: 'https://chill-uat-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+RetrieveResume+Quote+Guide.pdf',
      assumptionsUrl: 'https://www.chill.ie/home-insurance/assumptions/',
      gtm: 'GTM-TTC826',
      noResultPhoneNumber: '01 279 9870'
    },
    {
      name: 'Chill',
      brokerId: '01',
      domain: 'uat-fd-hfq.chill.ie',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.chill.ie/company/legal/privacy-policy/',
      termsOfBusinessUrl: 'https://www.chill.ie/company/legal/terms-of-business/',
      journeyGuideUrl: 'https://chill-uat-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+Car+%26+Home+Quote+Journey+Guide.pdf',
      retrieveJourneyGuideUrl: 'https://chill-uat-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+RetrieveResume+Quote+Guide.pdf',
      assumptionsUrl: 'https://www.chill.ie/home-insurance/assumptions/',
      gtm: 'GTM-TTC826',
      noResultPhoneNumber: '01 279 9870'
    },
    {
      name: 'Chill',
      brokerId: '01',
      domain: 'localhost',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.chill.ie/company/legal/privacy-policy/',
      termsOfBusinessUrl: 'https://www.chill.ie/company/legal/terms-of-business/',
      journeyGuideUrl: 'https://chill-uat-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+Car+%26+Home+Quote+Journey+Guide.pdf',
      retrieveJourneyGuideUrl: 'https://chill-uat-cdn.s3.eu-west-1.amazonaws.com/guide/Chill+Insurance+-+RetrieveResume+Quote+Guide.pdf',
      assumptionsUrl: 'https://www.chill.ie/home-insurance/assumptions/',
      gtm: 'GTM-7DRT',
      noResultPhoneNumber: '01 279 9870'
    },
    {
      name: 'QD',
      brokerId: '04',
      domain: 'localhost',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.quotedevil.ie/docs/privacy-policy-data-protection/Privacy-Policy-Statement.pdf',
      termsOfBusinessUrl: 'https://www.quotedevil.ie/terms-and-conditions',
      journeyGuideUrl: 'https://staging.quotedevil.ie/docs/Quote%20Devil%20-%20Car%20&%20Home%20Quote%20Journey%20Guide.pdf',
      retrieveJourneyGuideUrl: 'https://staging.quotedevil.ie/docs/Quote%20Devil%20-%20RetrieveResume%20Quote%20Guide.pdf',
      assumptionsUrl: '',
      gtm: 'GTM-KHQBGWL',
      noResultPhoneNumber: '01 969 6236'
    },
    {
      name: 'Quote Devil',
      brokerId: '04',
      domain: 'hfq.quotedevil.ie',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.quotedevil.ie/docs/privacy-policy-data-protection/Privacy-Policy-Statement.pdf',
      termsOfBusinessUrl: 'https://www.quotedevil.ie/terms-and-conditions',
      journeyGuideUrl: 'https://www.quotedevil.ie/docs/Quote%20Devil%20-%20Car%20&%20Home%20Quote%20Journey%20Guide.pdf',
      retrieveJourneyGuideUrl: 'https://www.quotedevil.ie/docs/Quote%20Devil%20-%20RetrieveResume%20Quote%20Guide.pdf',
      assumptionsUrl: '',
      gtm: 'GTM-KHQBGWL',
      noResultPhoneNumber: '01 969 6236'
    },
    {
      name: 'Quote Devil',
      brokerId: '04',
      domain: 'dev-hfq.quotedevil.ie',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.quotedevil.ie/docs/privacy-policy-data-protection/Privacy-Policy-Statement.pdf',
      termsOfBusinessUrl: 'https://www.quotedevil.ie/terms-and-conditions',
       journeyGuideUrl: 'https://staging.quotedevil.ie/docs/Quote%20Devil%20-%20Car%20&%20Home%20Quote%20Journey%20Guide.pdf',
      retrieveJourneyGuideUrl: 'https://staging.quotedevil.ie/docs/Quote%20Devil%20-%20RetrieveResume%20Quote%20Guide.pdf',
      assumptionsUrl: '',
      gtm: 'GTM-MR4XJ79F',
      noResultPhoneNumber: '01 969 6236'
    },
    {
      name: 'Quote Devil',
      brokerId: '04',
      domain: 'uat-hfq.quotedevil.ie',
      email: '',
      phone: '',
      privacyPolicyUrl: 'https://www.quotedevil.ie/docs/privacy-policy-data-protection/Privacy-Policy-Statement.pdf',
      termsOfBusinessUrl: 'https://www.quotedevil.ie/terms-and-conditions',
      journeyGuideUrl: 'https://staging.quotedevil.ie/docs/Quote%20Devil%20-%20Car%20&%20Home%20Quote%20Journey%20Guide.pdf',
      retrieveJourneyGuideUrl: 'https://staging.quotedevil.ie/docs/Quote%20Devil%20-%20RetrieveResume%20Quote%20Guide.pdf',
      assumptionsUrl: '',
      gtm: 'GTM-MR4XJ79F',
      noResultPhoneNumber: '01 969 6236'
    }
  ]

  getDomain(): string {
    return window.location.hostname;
  }

  getBrokerDetailFromDomain(): BrokerDetail {

    const domain = this.getDomain();

    //const broker = this.brokerList.filter(x=> domain.includes(x.domain))[0]
    const broker = this.brokerList.filter(x => domain == x.domain)[0]

    return broker

  }

  applyChillStyle() {

    this.titleService.setTitle('HFQ Chill')

    document.documentElement.style.setProperty('--primary-color', '#5A2293');
    document.documentElement.style.setProperty('--primary-color-light', '#5D39B5');
    document.documentElement.style.setProperty('--primary-color-dark', '#492D82');
    document.documentElement.style.setProperty('--primary-color-background-light', '#F5ECFF');

    document.documentElement.style.setProperty('--secondary-color', '#A3C63A');
    document.documentElement.style.setProperty('--secondary-color-light', '#d1e39d');
    document.documentElement.style.setProperty('--secondary-color-dark', '#869d27');

    document.documentElement.style.setProperty('--tertiary-color', '#28B9D6');
    document.documentElement.style.setProperty('--tertiary-color-light', '#93dceb');
    document.documentElement.style.setProperty('--tertiary-color-dark', '#145c6b');

    document.documentElement.style.setProperty('--footer-background-color', '#F4F4EB');

    this.setFavicon('01')

  }

  applyQDStyle() {

    this.titleService.setTitle('HFQ Quote Devil')

    document.documentElement.style.setProperty('--primary-color', '#AB1C21');
    document.documentElement.style.setProperty('--primary-color-light', '#AB1C21');
    document.documentElement.style.setProperty('--primary-color-dark', '#AB1C21');
    document.documentElement.style.setProperty('--primary-color-background-light', '#EAD3D5');

    document.documentElement.style.setProperty('--secondary-color', '#3A3A3A');
    document.documentElement.style.setProperty('--secondary-color-light', '#F8F8F8');
    document.documentElement.style.setProperty('--secondary-color-dark', '#9e181c');

    document.documentElement.style.setProperty('--tertiary-color', '#28B9D6');
    document.documentElement.style.setProperty('--tertiary-color-light', '#93dceb');
    document.documentElement.style.setProperty('--tertiary-color-dark', '#145c6b');

    document.documentElement.style.setProperty('--footer-background-color', '#3C3C3C');

    this.setFavicon('04')
  }

  setFavicon(brokerId: string) {
    this.faviconElement = document.querySelector<HTMLLinkElement>('link[rel*="icon"]');
    if (!this.faviconElement) {
      this.faviconElement = document.createElement('link');
      this.faviconElement.rel = 'icon';
      document.head.appendChild(this.faviconElement);
    }

    if (brokerId == '04')
      this.faviconElement.href = 'assets/images/faviconQD.ico';
    else if (brokerId == '01')
      this.faviconElement.href = 'favicon.ico';
  }

}

export interface BrokerDetail {

  name: string,
  email: string,
  phone: string,
  brokerId: string,
  domain: string
  privacyPolicyUrl: string
  termsOfBusinessUrl: string
  assumptionsUrl: string
  gtm: string,
  noResultPhoneNumber: string,
  journeyGuideUrl?: string
  retrieveJourneyGuideUrl?: string
 }
